export default {
    errorModalGenericTitle:"Atención",
    errorModalGenericDescription:"Ha ocurrido un error. Por favor reintentá la operación nuevamente.",
    reportError:'Si el problema persiste podés reportar el error a través del sistema de consulta, haciendo',
    mailTo:'mailto:sac@plataforma10.com',
    clickHere:'click aquí.'
}